import { NgIf } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { FieldType, FormlyFieldProps } from '@ngx-formly/bootstrap/form-field';
import { FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { CheckboxModule } from 'primeng/checkbox';
import { SelectModule } from 'primeng/select';

interface CheckboxFieldProps extends FormlyFieldProps {
  checkboxLabel: string;
  secondaryLabel: string;
  requiredTrue: boolean;
  disableBottomMargin: boolean;
  smallBottomSpacing: boolean;
  isInitiallyChecked: boolean;
}

@Component({
  selector: 'app-checkbox-field',
  imports: [
    ReactiveFormsModule,
    FormlyModule,
    SelectModule,
    CheckboxModule,
    NgIf,
    FormsModule,
  ],
  templateUrl: './checkbox-field.component.html',
  styleUrl: './checkbox-field.component.scss',
})
export class CheckboxFieldComponent
  extends FieldType<FieldTypeConfig<CheckboxFieldProps>>
  implements OnInit
{
  public ngOnInit(): void {
    if (this.props.required || this.props.requiredTrue) {
      this.formControl.setValidators(Validators.requiredTrue);
    }

    if (this.props.isInitiallyChecked) {
      this.formControl.setValue(true);
    }
  }
}
